import { TrialPartnerListPage } from "@/features/rso/pages/TrialPartnerList";
import React from "react";

const TrialMatchList = () => {
  return <TrialPartnerListPage />;
};

export default TrialMatchList;
